import React, { Component } from "react"
import {
	is,
	ROLE_PARENT,
	ROLE_TEACHER,
	ROLE_SUPERADMIN
} from '../../services/contentServices'
import { connect } from 'react-redux'
import { withStyles } from "material-ui/styles"
import NavLink from "./NavLink"
import AuthContainer from '../containers/AuthContainer';
import Grid from 'material-ui/Grid';

const styles = {
	navigation: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: "#FFFFFF",
		padding: "10px 2em",
	},
	menu: {
		display: 'flex',
		alignItems: 'center',
		height: '100%'
	}
};

class Navigation extends Component {
	state = {
		links: []
	}
	componentDidMount() {
		this.initLinks(this.props)
	}
	componentWillReceiveProps(props) {
		this.initLinks(props)
	}

	initLinks = (props) => {
		if (props.account && props.account.user) {
			let accountId = props.account.user.account_id
			let links = [
				/* {
					'name': "dashboard",
					'icon': "tune",
					'path': "/admin",
					show: () => true
				}, */
				{
					'name': "admin",
					'icon': "settings",
					'path': "/admin/stages/",
					show: () => is(
						props.account, [ROLE_SUPERADMIN]
					)
				},
				{
					'name': "accounts",
					'icon': "supervisor_account",
					'path': "/admin/accounts/",
					show: () => is(
						props.account, [ROLE_SUPERADMIN]
					)
				},
				{
					'name': "settings",
					'icon': "build",
					'path': "/admin/settings/currency",
					show: () => false
				},
				{
					'name': "school",
					'icon': "school",
					'path': "/admin/accounts/" + accountId,
					show: () => is(
						props.account, [ROLE_TEACHER]
					)
				}
			]
			this.setState({ links })
		}
	}

	classes = this.props.classes

	render() {
		const { links } = this.state
		const {account} = this.props
		const isAdmin = account && account.user && account.user.type === 'superadmin'
		return isAdmin ? (

			<nav className={this.classes.navigation}>
				<Grid container className={'container-max-width'}>
					<Grid item xs={12} >
						<div className={this.classes.menu}>
							{links.map((link, index) => {
								if (link.show()) {
									return (
										<NavLink
											key={index}
											path={link.path}
											name={link.name}
											icon={link.icon}
										/>
									);
								}
							})}
						</div>
					</Grid>
					{/* <Grid item xs={4}>
						<AuthContainer />
					</Grid> */}
				</Grid>

			</nav>

		) : null;
	}
}

Navigation = connect(
	state => ({
		account: state.account
	})
)(Navigation);

export default withStyles(styles)(Navigation);



// WEBPACK FOOTER //
// ./src/components/navigation/Navigation.js